import PhoneInput from 'react-phone-input-international'
import 'react-phone-input-international/lib/style.css'
import phone from 'phone'

export default function PhoneNumber({ response, setResponse, type = "text", placeholder = "Type an answer...", disabled = false, className = '' }) {
  const [rawValue, setRawValue] = useState(response || '');

  useEffect(() => {
    if (response !== undefined) {
      setRawValue(response);
    }
  }, [response]);

  const handleChange = (value, countryData) => {
    setRawValue(value)

    if (value) {
      const formatted = phone(value, { 
        country: countryData?.countryCode?.toUpperCase() || 'GB' 
      });

      if (formatted.isValid) {
        setResponse(formatted.phoneNumber)
      } else {
        setResponse(value)
      }
    } else {
      setResponse('')
    }
  }

  return (
    <div className={`answers grow ${className}`}>
      <PhoneInput
        placeholder={placeholder}
        country='gb'
        preferredCountries={['gb']}
        value={rawValue} // Use the raw value for display
        autoFormat={false}
        disableCountryCode
        disabled={disabled}
        onChange={handleChange}
      />
    </div>
  )
}
